import { render, staticRenderFns } from "./GuoNaiZeroCollector.vue?vue&type=template&id=79021fbc&scoped=true"
import script from "./GuoNaiZeroCollector.vue?vue&type=script&lang=js"
export * from "./GuoNaiZeroCollector.vue?vue&type=script&lang=js"
import style0 from "./GuoNaiZeroCollector.vue?vue&type=style&index=0&id=79021fbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79021fbc",
  null
  
)

export default component.exports